var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 33,
    viewBox: "0 0 27 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8761 25.1921C16.8761 20.4041 19.1441 19.1441 19.1441 19.1441C22.2941 15.9941 22.4503 11.0473 19.3028 7.89729C17.7906 6.38537 15.7398 5.53601 13.6013 5.53601C11.4629 5.53601 9.41209 6.38537 7.89985 7.89729C4.74985 11.0473 4.90609 15.9941 8.05609 19.1441C8.05609 19.1441 10.3241 20.4041 10.3241 25.1921H16.8761Z",
    stroke: "#106C3A",
    strokeWidth: 2.016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1119 31.24H12.0879",
    stroke: "#106C3A",
    strokeWidth: 2.016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1201 28.2159H11.0801",
    stroke: "#106C3A",
    strokeWidth: 2.016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3479 1V2.512",
    stroke: "#106C3A",
    strokeWidth: 2.016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 13.348H2.512",
    stroke: "#106C3A",
    strokeWidth: 2.016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.688 13.348H25.696",
    stroke: "#106C3A",
    strokeWidth: 2.016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61621 22.0798L5.68469 21.0114",
    stroke: "#106C3A",
    strokeWidth: 2.016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3667 5.32937L22.0799 4.61621",
    stroke: "#106C3A",
    strokeWidth: 2.016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61621 4.61621L5.68469 5.68469",
    stroke: "#106C3A",
    strokeWidth: 2.016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3667 21.3666L22.0799 22.0797",
    stroke: "#106C3A",
    strokeWidth: 2.016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.6532bc0348c5ee09253e3675532373ed.svg";
export { ForwardRef as ReactComponent };